import { c as _c } from "react/compiler-runtime";
import { getMarketplaceLogo } from "../../marketplaces/marketplace-logos";
export function MarketplaceIcon(t0) {
  const $ = _c(8);
  let market;
  let rest;
  if ($[0] !== t0) {
    ({
      market,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = market;
    $[2] = rest;
  } else {
    market = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== market) {
    t1 = getMarketplaceLogo(market);
    $[3] = market;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    icon: Logo
  } = t1;
  if (!Logo) {
    return null;
  }
  let t2;
  if ($[5] !== Logo || $[6] !== rest) {
    t2 = <Logo {...rest} />;
    $[5] = Logo;
    $[6] = rest;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}